export function prettifySepa(sepa: {
  country: string;
  bank_code: string;
  branch_code: string;
  last4: string;
}) {
  return `${sepa.country}## ${sepa.bank_code.slice(0, 4)} ${sepa.bank_code.slice(4)}${sepa.branch_code.slice(0, 3)} ${sepa.branch_code.slice(3, 5)}## #### ###${sepa.last4.slice(0, 1)} ${sepa.last4.slice(1)}`;
}
